// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__yAKQs","requiredAsterisk":"Info_requiredAsterisk__3fGqQ"};